var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        width: "900px",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "span",
            { staticStyle: { "font-weight": "bold", "margin-right": "10px" } },
            [_vm._v("服务项目ID:")]
          ),
          _vm._v(" "),
          _c("el-input", {
            staticStyle: { width: "250px" },
            attrs: {
              placeholder: "请输入服务项目ID (例如: aqjc001)",
              size: "small",
              clearable: "",
            },
            model: {
              value: _vm.serviceItemId,
              callback: function ($$v) {
                _vm.serviceItemId = $$v
              },
              expression: "serviceItemId",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                color: "#999",
                "font-size": "12px",
                "margin-left": "10px",
              },
            },
            [_vm._v("* 必填，请确认ID正确")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-upload",
        {
          ref: "upload",
          staticStyle: { display: "inline-block", "margin-right": "10px" },
          attrs: {
            action: "",
            limit: 1,
            "http-request": _vm.uploadFile,
            "show-file-list": false,
            accept: ".xlsx, .xls",
          },
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", icon: "el-icon-upload2" },
            },
            [_vm._v("点击上传 Excel")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("span", { staticStyle: { margin: "10px 0", "font-size": "13px" } }, [
        _vm._v("\n    下载导入模板: "),
        _c("span", { staticClass: "blue", on: { click: _vm.downloadFile } }, [
          _vm._v("安全检测订单模板.xlsx"),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "ql-table",
          staticStyle: { "margin-top": "20px" },
          attrs: {
            data: _vm.tableData,
            "highlight-current-row": "",
            "header-cell-style": { fontWeight: "bold", background: "#f5f7fa" },
            height: "400",
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "entryTime",
              label: "进店时间",
              "min-width": "140",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "licensePlate",
              label: "车牌号",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "policyNo",
              label: "保单号",
              "min-width": "150",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "agency",
              label: "归属机构",
              "min-width": "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "isNewEnergy",
              label: "是否新能源",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "brand",
              label: "品牌",
              "min-width": "100",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "shopName",
              label: "进店名称",
              "min-width": "150",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "导入结果",
              "min-width": "200",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    !scope.row.reason
                      ? _c("span", { staticStyle: { color: "green" } }, [
                          _vm._v("成功"),
                        ])
                      : _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(_vm._s(scope.row.reason)),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }